module.exports = __webpack_public_path__ + "img/foto_11.47846793.png";